var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25995 13.5208L2.39495 8.65582L0.738281 10.3008L7.25995 16.8225L21.2599 2.82249L19.6149 1.17749L7.25995 13.5208Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25995 13.5208L6.90639 13.8744L7.25978 14.2278L7.61333 13.8745L7.25995 13.5208ZM2.39495 8.65582L2.7485 8.30227L2.39619 7.94997L2.04265 8.30102L2.39495 8.65582ZM0.738281 10.3008L0.385979 9.94602L0.0299231 10.2996L0.384728 10.6544L0.738281 10.3008ZM7.25995 16.8225L6.90639 17.176L7.25995 17.5296L7.6135 17.176L7.25995 16.8225ZM21.2599 2.82249L21.6135 3.17604L21.9671 2.82249L21.6135 2.46894L21.2599 2.82249ZM19.6149 1.17749L19.9685 0.823937L19.6151 0.47055L19.2616 0.82377L19.6149 1.17749ZM7.6135 13.1673L2.7485 8.30227L2.04139 9.00938L6.90639 13.8744L7.6135 13.1673ZM2.04265 8.30102L0.385979 9.94602L1.09058 10.6556L2.74725 9.01062L2.04265 8.30102ZM0.384728 10.6544L6.90639 17.176L7.6135 16.4689L1.09183 9.94727L0.384728 10.6544ZM7.6135 17.176L21.6135 3.17604L20.9064 2.46894L6.90639 16.4689L7.6135 17.176ZM21.6135 2.46894L19.9685 0.823937L19.2614 1.53104L20.9064 3.17604L21.6135 2.46894ZM19.2616 0.82377L6.90656 13.1671L7.61333 13.8745L19.9683 1.53121L19.2616 0.82377Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.1da2bd67.svg";
export { ForwardRef as ReactComponent };